/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import OrderItem from './components/OrderItem';
import RefundPopup from './components/RefundPopup';
import LoadLine from './components/LoadLine';
import BScroll from '@/components/Bscroll';
import NoData from '@/components/NoData';
import NoDataImg from '@/resources/images/mall/noOrder.png';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { GetOrderList, OrderEdit, GetOrderDetail } from '@/api/mall';
import Public from '@/common/Public';
export default {
  data: function data() {
    return {
      orderList: [],
      NoDataImg: NoDataImg,
      show: false,
      nowOrderNo: '',
      loadStatus: -1,
      pageSize: 10,
      pageNo: 1,
      showFlag: -1,
      nowOrderObj: {},
      status: ''
    };
  },
  created: function created() {
    this.status = this.$route.query.status; // this.orderList =[];

    this.getOrderList();
  },
  components: {
    OrderItem: OrderItem,
    NoData: NoData,
    RefundPopup: RefundPopup,
    BScroll: BScroll,
    LoadLine: LoadLine
  },
  computed: _objectSpread({}, mapState({})),
  methods: _objectSpread(_objectSpread({}, mapActions([])), {}, {
    //返回微商城主页
    goMall: function goMall() {
      this.$router.push({
        name: 'MallIndex'
      });
    },
    //退款成功后回调
    refundConfirm: function refundConfirm(text, orderNo, data) {
      var orderItem = this.orderList.find(function (x) {
        return x.orderNo == orderNo;
      });

      if (data) {
        Public.tips({
          text: '申请提交成功'
        });
        orderItem.orderStatus = 7;
      } else {
        GetOrderDetail(orderNo).then(function (data) {
          orderItem.orderStatus = data.orderStatus;
        });
      }

      this.show = false;
    },
    //设置退款弹窗
    setShow: function setShow(val) {
      this.show = val;
    },
    //显示退款弹窗
    refundPopShow: function refundPopShow(orderObj) {
      this.show = true;
      this.nowOrderObj = orderObj;
      this.nowOrderNo = orderObj.orderNo;
    },
    //滚动
    scrollToEndEvnet: function scrollToEndEvnet() {
      if (this.loadStatus == 2) {
        return;
      }

      this.pageNo++;
      this.getOrderList(); //第N次加载完成列表数据
    },
    //订单列表查询
    getOrderList: function getOrderList() {
      var _this = this;

      this.loadStatus = 0;
      var param = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        queryType: this.status
      };

      if (this.pageNo == 1) {
        this.orderList = [];
      }

      console.log(param, '传出去的数据');
      GetOrderList(param).then(function (data) {
        if (data.totalPage <= data.currentPage) {
          _this.loadStatus = 2;
        } else {
          _this.loadStatus = 1;
        }

        _this.orderList = [].concat(_toConsumableArray(_this.orderList), _toConsumableArray(data.dataSource));

        if (_this.orderList.length > 0) {
          _this.showFlag = 1;
        } else {
          _this.showFlag = 0;
        }
      });
    },
    //查看订单详情
    goOrderDetail: function goOrderDetail(orderNo) {
      this.$router.push({
        name: 'MallOrderDetail',
        query: {
          orderNo: orderNo
        }
      });
    },
    //订单操作成功的回调函数
    orderHandleDone: function orderHandleDone(status, orderNo, msg) {
      var orderItem = this.orderList.find(function (x) {
        return x.orderNo == orderNo;
      });
      orderItem.orderStatus = status;

      if (msg && msg.length > 0) {
        Public.tips({
          text: msg
        });
      }
    },
    blur: function blur() {
      //IOS 虚拟键盘顶起内容不下
      if (Public.getSystemInfo().sysType === 1) {
        document.body.scrollTop = 0;
      }
    }
  })
};